import { fireIssueCreateErrorAnalytics as fireErrorAnalytics } from '@atlassian/jira-issue-create-analytics-common/src/utils/fire-error-analytics/index.tsx';
import { performPostRequest } from '@atlassian/jira-fetch/src/utils/requests.tsx';
import { StatusFieldLoad } from '@atlassian/jira-issue-create-analytics/src/services/experiences/index.tsx';
import { transformData } from './transformer.tsx';

const constructEndpoint = (cloudId: string) =>
	`/gateway/api/jira/project-configuration/query/${cloudId}/2/transition/initial`;

const getTransitions = async (cloudId: string, projectId: string, issueTypeId: string) => {
	const url = constructEndpoint(cloudId);

	StatusFieldLoad.start();

	try {
		const resp = await performPostRequest(url, {
			body: JSON.stringify({
				projectId,
				issueTypeId,
			}),
		});

		StatusFieldLoad.success();
		return transformData(resp);
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
	} catch (error: any) {
		StatusFieldLoad.failure();
		fireErrorAnalytics({
			meta: {
				id: 'getTransitions',
				packageName: 'jiraIssueCreate',
				teamName: 'gryffindor',
			},
			error,
			sendToPrivacyUnsafeSplunk: true,
		});
		throw error;
	}
};

export default getTransitions;
